export const LIST_FILTER_TO_ITSELF_PREFIX = 'ListFilterToItself-'

export const TABS_HEIGHT = 85

export const BOTTOM_GAP = 105

export const MODAL_BOTTOM_GAP = 190
